import React from 'react';
import styled from 'styled-components';
import { Box, Typography, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContainer = styled(Box)`
  background-color: white;
  border-radius: 16px;
  padding: 24px;
  width: 85%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  position: relative;
  border: 2px solid #FF69B4;
`;

const EyeIcon = styled.div`
  position: absolute;
  top: -26px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 88px;
  height: 53px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #FF69B4;
  z-index: 1001;
`;

const CloseButton = styled(IconButton)`
  position: absolute;
  top: 0px;
  right: -160px;
  color: #666;
  z-index: 1002;
`;

const Header = styled(Typography)`
  color: #FF69B4;
  font-weight: bold;
  margin-bottom: 16px;
  text-align: center;
  margin-top: 16px;
  font-size: 1.5rem;
`;

const Description = styled(Typography)`
  text-align: center;
  margin-bottom: 24px;
  color: #555;
  line-height: 1.6;
  font-size: 0.95rem;
`;

const ActivateButton = styled(Button)`
  background-color: #FF69B4;
  color: white;
  padding: 14px 40px;
  border-radius: 30px;
  font-weight: bold;
  text-transform: none;
  box-shadow: 0 4px 8px rgba(255, 105, 180, 0.3);
  font-size: 1.1rem;
  margin-top: 8px;
  min-width: 180px;
  &:hover {
    background-color: #FF4DA6;
  }
`;

const JJMuseModal = ({ onActivate, onClose }) => {
  return (
    <ModalOverlay>
      <ModalContainer>
        <EyeIcon>
          <img src="/eye.png" alt="Eye" width="88" height="53" />
        </EyeIcon>
        
        <CloseButton onClick={onClose} aria-label="close">
          <CloseIcon />
        </CloseButton>
        
        <Header variant="h5">JJ Muse</Header>
        
        <Description variant="body1">
          JustJam Muse is your very own A.I. agent designed to help you 
          navigate the music industry.<br /><br />JJ Muse grows with you to help you achieve 
          your goals and optimize your time effectively.
        </Description>
        
        <ActivateButton 
          variant="contained" 
          onClick={onActivate}
        >
          ACTIVATE
        </ActivateButton>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default JJMuseModal;
